function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M726.349,203.727c-16.903-76.767-75.724-137.36-155.822-157.652 c-21.059-5.335-43.457-8.031-65.745-5.737c-91.089,9.378-199.751,70.675-256.129,83.525 c-56.379,12.85-122.489-38.55-197.465,40.386c-74.975,78.936-57.654,261.589,92.262,297.385 c149.915,35.796,233.36-52.318,299.951-33.043c66.591,19.275,185.809,11.014,256.205-45.893 C741.349,348.954,741.019,270.353,726.349,203.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M726.349,203.727c-16.903-76.767-75.724-137.36-155.822-157.652 c-21.059-5.335-43.457-8.031-65.745-5.737c-91.089,9.378-199.751,70.675-256.129,83.525 c-56.379,12.85-122.489-38.55-197.465,40.386c-74.975,78.936-57.654,261.589,92.262,297.385 c149.915,35.796,233.36-52.318,299.951-33.043c66.591,19.275,185.809,11.014,256.205-45.893 C741.349,348.954,741.019,270.353,726.349,203.727z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bricks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 374.758,
    y: 221.518,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.996,
    y: 177.043,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.257,
    y: 221.15,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.1,
    y: 134.193,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.916,
    y: 134.193,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.328,
    y: 313.563,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.156,
    y: 329.001,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.088,
    y: 194.318,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.401,
    y: 264.523,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.561,
    y: 283.636,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.847,
    y: 283.636,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.787,
    y: 265.993,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.374,
    y: 194.318,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.852,
    y: 94.796,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.09,
    y: 50.321,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.182,
    y: 67.597,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.468,
    y: 67.597,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.484,
    y: 327.743,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.576,
    y: 345.019,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.862,
    y: 345.019,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.807,
    y: 172.199,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.899,
    y: 189.475,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.185,
    y: 189.475,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.757,
    y: 265.258,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.49,
    y: 205.5,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.177,
    y: 328.266,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.743,
    y: 118.756,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.114,
    y: 223.878,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.757,
    y: 208.441,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.415,
    y: 133.303,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.743,
    y: 221.518,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.148,
    y: 221.518,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 991.1718 455.5333)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 491.91,
    y: 177.043,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1014.6958 366.5833)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.649,
    y: 221.15,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1238.1733 454.7981)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558.807,
    y: 134.193,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1148.4882 280.8833)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.991,
    y: 134.193,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1080.8568 280.8833)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.818,
    y: 194.318,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1048.5114 401.1341)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.505,
    y: 264.523,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 955.8858 541.5427)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.346,
    y: 283.636,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1317.5668 579.7691)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.06,
    y: 283.636,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1246.9948 579.7691)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.119,
    y: 265.993,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1241.1138 544.4833)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.532,
    y: 194.318,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 977.9396 401.1341)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.742,
    y: 377.466,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 496.3602 767.4293)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.65,
    y: 394.741,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 530.1758 801.9801)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.364,
    y: 394.741,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 459.604 801.9801)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.289,
    y: 377.466,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 197.4536 767.4293)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.197,
    y: 394.741,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 231.2692 801.9801)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.911,
    y: 394.741,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 160.6974 801.9801)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 565.423,
    y: 327.743,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1161.7205 667.984)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.331,
    y: 345.019,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1195.5361 702.5349)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 547.045,
    y: 345.019,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1124.9644 702.5349)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.417,
    y: 205.5,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1211.709 423.4973)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.73,
    y: 328.266,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1304.3346 669.0287)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.117,
    y: 345.836,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1003.1098 704.1697)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.831,
    y: 345.836,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 932.5378 704.1697)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.194,
    y: 389.944,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 847.2635 792.3846)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.966,
    y: 407.219,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1374.8082 826.9355)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.966,
    y: 375.255,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1374.8082 763.0073)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.789,
    y: 390.805,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1406.4528 794.1075)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.369,
    y: 390.805,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1335.6136 794.1075)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.501,
    y: 390.466,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 989.8776 793.4293)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 519.957,
    y: 431.914,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.049,
    y: 449.189,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 538.335,
    y: 449.189,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.76,
    y: 420.887,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.853,
    y: 449.189,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 641.139,
    y: 449.189,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.294,
    y: 461.667,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.578,
    y: 445.253,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.561,
    y: 429.703,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.739,
    y: 445.253,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.159,
    y: 445.253,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.164,
    y: 118.756,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1113.2024 250.0081)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.75,
    y: 66.058,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1080.3744 144.6133)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.492,
    y: 133.303,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1327.8584 279.1035)",
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 541.164,
    y: 221.518,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 1113.2024 455.5333)",
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.191,
    y: 48.45,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.448,
    y: 137.002,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.949,
    y: 147.782,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.487,
    y: 160.103,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.265,
    y: 160.658,
    style: {
      opacity: 0.1
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.298,
    y: 65.974,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.056,
    y: 48.45,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.163,
    y: 65.974,
    style: {
      opacity: 0.2
    },
    width: 30.875,
    height: 12.497
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Pipes"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M91.206,213.381 H11.565v-13h73.141V12.203h13v194.678C97.706,210.471,94.796,213.381,91.206,213.381z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M694.253,7.741 v74.43H97.43v13h575.937v314.2H519.748c-3.59,0-6.5,2.91-6.5,6.5v47.861h13V422.37h147.119v43.973h13V95.17h14.386 c3.59,0,6.5-2.91,6.5-6.5V7.741H694.253z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.443,
    y: 47.799,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 12.7,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.802,
    y: 412.976,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 985.0781 -153.2246)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 12.699,
    height: 5.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.649,
    y: 412.976,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 997.9257 -166.0723)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 12.699,
    height: 5.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.943,
    y: 433.067,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 209.636,
    height: 13
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.943,
    y: 415.153,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 209.636,
    height: 13
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.379,
    y: 415.396,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.965,
    height: 12.633
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.055,
    y: 415.396,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.965,
    height: 12.633
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 119.379,
    y: 433.31,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.965,
    height: 12.633
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.055,
    y: 433.31,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.965,
    height: 12.633
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gears"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M268.078,172.488 v-17.146h-10.442c-0.503-2.871-1.241-5.661-2.217-8.338l9.023-5.209l-8.573-14.849l-9.043,5.221 c-1.852-2.205-3.893-4.245-6.098-6.096l5.219-9.039l-14.849-8.573l-5.212,9.027c-2.678-0.975-5.468-1.712-8.339-2.214v-10.438 H200.4v10.442c-2.871,0.503-5.661,1.241-8.338,2.217l-5.209-9.023l-14.849,8.573l5.221,9.043c-2.205,1.852-4.244,3.893-6.096,6.098 l-9.039-5.219l-8.573,14.849l9.027,5.212c-0.975,2.678-1.712,5.468-2.214,8.339h-10.438v17.146h10.442 c0.503,2.871,1.241,5.661,2.217,8.338l-9.023,5.209l8.573,14.849l9.043-5.221c1.852,2.205,3.893,4.245,6.098,6.096l-5.219,9.039 l14.849,8.573l5.212-9.027c2.678,0.975,5.468,1.712,8.339,2.214v10.438h17.146v-10.442c2.871-0.503,5.661-1.241,8.338-2.217 l5.209,9.023l14.849-8.573l-5.221-9.043c2.205-1.852,4.245-3.893,6.096-6.098l9.039,5.219l8.573-14.849l-9.027-5.212 c0.975-2.678,1.712-5.468,2.214-8.339H268.078z M208.986,195.875c-17.644,0-31.948-14.303-31.948-31.947 c0-17.644,14.303-31.947,31.948-31.947c17.644,0,31.948,14.303,31.948,31.947C240.933,181.572,226.63,195.875,208.986,195.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M190.128,329.914 v-17.146h-10.442c-0.503-2.871-1.241-5.66-2.217-8.338l9.023-5.209l-8.573-14.849l-9.043,5.221 c-1.852-2.205-3.893-4.245-6.098-6.096l5.219-9.039l-14.849-8.573l-5.212,9.027c-2.678-0.975-5.468-1.712-8.339-2.214v-10.438 h-17.146v10.442c-2.871,0.503-5.661,1.241-8.338,2.217l-5.209-9.023l-14.849,8.573l5.221,9.043 c-2.205,1.852-4.245,3.893-6.096,6.098l-9.039-5.219l-8.573,14.849l9.027,5.212c-0.975,2.678-1.712,5.468-2.214,8.339H71.943 v17.146h10.442c0.503,2.871,1.241,5.661,2.217,8.338l-9.023,5.209l8.573,14.849l9.043-5.221c1.852,2.205,3.893,4.244,6.098,6.096 l-5.219,9.039l14.849,8.573l5.212-9.027c2.678,0.975,5.468,1.712,8.339,2.214v10.438h17.146v-10.442 c2.871-0.503,5.66-1.241,8.338-2.217l5.209,9.023l14.849-8.573l-5.221-9.043c2.205-1.852,4.244-3.893,6.096-6.098l9.039,5.219 l8.573-14.849l-9.027-5.212c0.975-2.678,1.712-5.468,2.214-8.339H190.128z M131.036,353.301c-17.644,0-31.948-14.303-31.948-31.948 s14.303-31.947,31.948-31.947c17.644,0,31.947,14.303,31.947,31.947S148.68,353.301,131.036,353.301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M625.243,327.462 v-11.575h-7.049c-0.34-1.938-0.838-3.821-1.497-5.629l6.091-3.517l-5.787-10.024l-6.105,3.525 c-1.251-1.488-2.628-2.865-4.117-4.115l3.523-6.102l-10.024-5.787l-3.518,6.094c-1.808-0.658-3.691-1.156-5.629-1.494v-7.046 h-11.575v7.049c-1.938,0.34-3.821,0.838-5.629,1.497l-3.517-6.091l-10.024,5.787l3.525,6.105c-1.488,1.25-2.865,2.628-4.115,4.117 l-6.102-3.523l-5.787,10.024l6.094,3.518c-0.658,1.808-1.156,3.691-1.494,5.629h-7.046v11.575h7.049 c0.34,1.938,0.838,3.821,1.497,5.629l-6.091,3.517l5.787,10.024l6.105-3.525c1.25,1.488,2.628,2.865,4.117,4.115l-3.523,6.102 l10.024,5.787l3.518-6.094c1.808,0.658,3.691,1.156,5.629,1.494v7.046h11.575v-7.049c1.938-0.34,3.821-0.838,5.629-1.497 l3.517,6.091l10.024-5.787l-3.525-6.105c1.488-1.251,2.865-2.628,4.115-4.117l6.102,3.523l5.787-10.024l-6.094-3.518 c0.658-1.808,1.156-3.691,1.494-5.629H625.243z M585.351,343.25c-11.911,0-21.567-9.656-21.567-21.567 c0-11.911,9.656-21.567,21.567-21.567c11.911,0,21.567,9.656,21.567,21.567C606.918,333.594,597.262,343.25,585.351,343.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M568.668,163.515 V151.94h-7.049c-0.34-1.938-0.838-3.821-1.497-5.629l6.091-3.517l-5.788-10.024l-6.105,3.525c-1.25-1.488-2.628-2.866-4.117-4.115 l3.523-6.102l-10.024-5.787l-3.518,6.094c-1.808-0.658-3.691-1.156-5.629-1.494v-7.046H522.98v7.049 c-1.938,0.34-3.821,0.838-5.629,1.497l-3.517-6.091l-10.024,5.787l3.525,6.105c-1.488,1.251-2.865,2.628-4.115,4.117l-6.102-3.523 l-5.787,10.024l6.094,3.518c-0.658,1.808-1.156,3.691-1.494,5.629h-7.046v11.575h7.049c0.34,1.938,0.838,3.821,1.497,5.629 l-6.091,3.517l5.788,10.024l6.105-3.525c1.25,1.488,2.628,2.865,4.117,4.115l-3.523,6.102l10.024,5.787l3.518-6.094 c1.808,0.658,3.691,1.156,5.629,1.494v7.046h11.575v-7.049c1.938-0.34,3.821-0.838,5.629-1.497l3.517,6.091l10.024-5.787 l-3.525-6.105c1.488-1.251,2.865-2.628,4.115-4.117l6.102,3.523l5.787-10.024l-6.094-3.518c0.658-1.808,1.156-3.691,1.494-5.629 H568.668z M528.776,179.303c-11.911,0-21.567-9.656-21.567-21.567c0-11.911,9.656-21.567,21.567-21.567 c11.911,0,21.567,9.656,21.567,21.567C550.343,169.647,540.687,179.303,528.776,179.303z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.543,390.415v-80.18H45.182v-51.332l89.513-212.115h76.361v213.388h33.09v50.06h-33.09v80.18 H149.543z M96.938,260.176h52.604V114.241L96.938,260.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M211.056,390.915h-61.513c-0.276,0-0.5-0.224-0.5-0.5v-79.68H45.182c-0.276,0-0.5-0.224-0.5-0.5 v-51.332c0-0.066,0.013-0.133,0.04-0.194l89.513-212.115c0.078-0.185,0.259-0.306,0.461-0.306h76.361c0.276,0,0.5,0.224,0.5,0.5 v212.888h32.59c0.276,0,0.5,0.224,0.5,0.5v50.06c0,0.276-0.224,0.5-0.5,0.5h-32.59v79.68 C211.556,390.691,211.333,390.915,211.056,390.915z M150.043,389.915h60.513v-79.68c0-0.276,0.224-0.5,0.5-0.5h32.59v-49.06 h-32.59c-0.276,0-0.5-0.224-0.5-0.5V47.288h-75.53L45.682,259.005v50.73h103.861c0.276,0,0.5,0.224,0.5,0.5V389.915z  M149.543,260.676H96.939c-0.163,0-0.315-0.079-0.409-0.213c-0.094-0.133-0.116-0.304-0.061-0.457l52.605-145.935 c0.082-0.229,0.32-0.36,0.556-0.323c0.239,0.042,0.414,0.25,0.414,0.493v145.935C150.043,260.452,149.82,260.676,149.543,260.676 z M97.65,259.676h51.393V117.102L97.65,259.676z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M367.173,396.355c-20.648,0-37.756-4.242-51.332-12.728c-13.575-8.484-23.757-20.15-30.544-34.999 c-6.788-14.848-10.182-32.029-10.182-51.544V143.089c0-20.078,3.248-37.684,9.757-52.816 c6.503-15.127,16.545-26.939,30.121-35.423c13.575-8.484,30.969-12.727,52.18-12.727c20.927,0,38.108,4.243,51.544,12.727 c13.43,8.484,23.399,20.297,29.909,35.423c6.503,15.133,9.758,32.739,9.758,52.816v153.996c0,19.515-3.395,36.696-10.182,51.544 c-6.789,14.849-16.97,26.515-30.545,34.999C404.081,392.112,387.251,396.355,367.173,396.355z M367.173,338.659 c7.636,0,13.151-2.4,16.545-7.212c3.394-4.806,5.654-10.533,6.788-17.182c1.126-6.642,1.697-12.793,1.697-18.454v-151.45 c0-6.218-0.497-12.727-1.485-19.515c-0.994-6.788-3.182-12.654-6.576-17.605c-3.394-4.945-9.055-7.424-16.969-7.424 c-7.921,0-13.648,2.479-17.181,7.424c-3.539,4.952-5.8,10.818-6.788,17.605c-0.995,6.788-1.485,13.297-1.485,19.515v151.45 c0,5.661,0.563,11.813,1.697,18.454c1.127,6.648,3.533,12.376,7.212,17.182C354.3,336.26,359.815,338.659,367.173,338.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M367.173,396.854c-20.645,0-38.005-4.308-51.597-12.804 c-13.597-8.498-23.937-20.346-30.734-35.215c-6.786-14.845-10.227-32.256-10.227-51.752V143.088 c0-20.063,3.296-37.899,9.798-53.014c6.516-15.156,16.715-27.15,30.315-35.649c13.593-8.496,31.238-12.803,52.445-12.803 c20.924,0,38.356,4.308,51.811,12.804c13.452,8.499,23.579,20.492,30.1,35.648c6.502,15.13,9.799,32.967,9.799,53.014v153.996 c0,19.494-3.44,36.906-10.227,51.752c-6.798,14.869-17.139,26.718-30.735,35.215 C404.329,392.547,387.255,396.854,367.173,396.854z M367.173,42.622c-21.017,0-38.483,4.256-51.915,12.651 c-13.424,8.39-23.493,20.231-29.926,35.197c-6.448,14.989-9.717,32.693-9.717,52.619v153.996c0,19.351,3.41,36.623,10.136,51.336 c6.714,14.689,16.927,26.391,30.355,34.783c13.431,8.395,30.612,12.651,51.067,12.651c19.892,0,36.788-4.257,50.218-12.651 c13.428-8.393,23.64-20.095,30.355-34.783c6.727-14.714,10.137-31.985,10.137-51.336V143.088c0-19.911-3.27-37.614-9.717-52.619 c-6.44-14.967-16.439-26.81-29.716-35.198C405.157,46.877,387.905,42.622,367.173,42.622z M367.173,339.159 c-7.491,0-13.191-2.492-16.942-7.408c-3.714-4.852-6.172-10.707-7.308-17.401c-1.13-6.626-1.704-12.863-1.704-18.538v-151.45 c0-6.249,0.501-12.839,1.49-19.587c0.994-6.835,3.308-12.832,6.875-17.824c3.619-5.065,9.536-7.634,17.588-7.634 c8.054,0,13.902,2.571,17.381,7.642c3.417,4.984,5.657,10.978,6.658,17.816c0.989,6.794,1.49,13.384,1.49,19.587v151.45 c0,5.635-0.573,11.872-1.704,18.538c-1.142,6.696-3.455,12.546-6.873,17.386C380.653,336.661,374.949,339.159,367.173,339.159z  M367.173,100.317c-7.711,0-13.354,2.427-16.774,7.215c-3.474,4.861-5.728,10.711-6.7,17.387 c-0.982,6.701-1.479,13.242-1.479,19.443v151.45c0,5.619,0.568,11.8,1.689,18.37c1.108,6.533,3.502,12.24,7.116,16.962 c3.553,4.655,8.985,7.016,16.148,7.016c7.432,0,12.861-2.355,16.136-7c3.332-4.718,5.587-10.43,6.704-16.978 c1.121-6.61,1.689-12.791,1.689-18.37v-151.45c0-6.155-0.498-12.696-1.479-19.443c-0.979-6.685-3.164-12.537-6.494-17.395 C380.448,102.742,374.878,100.317,367.173,100.317z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M598.378,390.415v-80.18h-104.36v-51.332L583.53,46.788h76.362v213.388h33.09v50.06h-33.09v80.18 H598.378z M545.774,260.176h52.605V114.241L545.774,260.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M659.892,390.915h-61.514c-0.276,0-0.5-0.224-0.5-0.5v-79.68h-103.86c-0.276,0-0.5-0.224-0.5-0.5 v-51.332c0-0.066,0.014-0.133,0.039-0.194l89.512-212.115c0.078-0.185,0.26-0.306,0.461-0.306h76.362c0.276,0,0.5,0.224,0.5,0.5 v212.888h32.59c0.276,0,0.5,0.224,0.5,0.5v50.06c0,0.276-0.224,0.5-0.5,0.5h-32.59v79.68 C660.392,390.691,660.168,390.915,659.892,390.915z M598.878,389.915h60.514v-79.68c0-0.276,0.224-0.5,0.5-0.5h32.59v-49.06 h-32.59c-0.276,0-0.5-0.224-0.5-0.5V47.288h-75.53l-89.344,211.717v50.73h103.86c0.276,0,0.5,0.224,0.5,0.5V389.915z  M598.378,260.676h-52.604c-0.163,0-0.316-0.079-0.409-0.213c-0.094-0.133-0.116-0.304-0.061-0.457l52.604-145.935 c0.083-0.229,0.314-0.365,0.557-0.323c0.239,0.042,0.414,0.25,0.414,0.493v145.935 C598.878,260.452,598.654,260.676,598.378,260.676z M546.485,259.676h51.393V117.103L546.485,259.676z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M291.746,467.292v-51.81h18.741v3.773h-13.816v19.445h11.258v3.581h-11.258v21.364h13.944v3.645 H291.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M317.267,467.292v-51.81h11.705c3.24,0,5.789,0.523,7.644,1.567 c1.855,1.045,3.187,2.558,3.997,4.541c0.81,1.982,1.215,4.339,1.215,7.067c0,1.919-0.214,3.732-0.64,5.438 c-0.427,1.706-1.151,3.156-2.175,4.35c-1.023,1.193-2.474,1.982-4.35,2.366l7.932,26.48h-4.733l-7.611-25.457h-8.124v25.457 H317.267z M322.128,438.253h6.588c2.175,0,3.859-0.361,5.053-1.087c1.193-0.725,2.047-1.791,2.559-3.198 c0.512-1.407,0.768-3.177,0.768-5.31c0-3.198-0.555-5.585-1.663-7.163c-1.109-1.577-3.305-2.367-6.588-2.367h-6.716V438.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M350.015,467.292v-51.81h11.705c3.24,0,5.789,0.523,7.644,1.567s3.187,2.558,3.998,4.541 c0.81,1.982,1.215,4.339,1.215,7.067c0,1.919-0.214,3.732-0.64,5.438c-0.427,1.706-1.151,3.156-2.175,4.35 c-1.023,1.193-2.474,1.982-4.35,2.366l7.932,26.48h-4.733L363,441.835h-8.124v25.457H350.015z M354.876,438.253h6.588 c2.175,0,3.859-0.361,5.053-1.087c1.193-0.725,2.047-1.791,2.559-3.198c0.512-1.407,0.768-3.177,0.768-5.31 c0-3.198-0.555-5.585-1.663-7.163c-1.109-1.577-3.305-2.367-6.588-2.367h-6.716V438.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M394.981,467.932c-3.412,0-6.087-0.672-8.027-2.015c-1.941-1.344-3.305-3.22-4.094-5.629 c-0.789-2.408-1.183-5.17-1.183-8.283v-21.491c0-3.155,0.415-5.895,1.247-8.22c0.832-2.323,2.217-4.125,4.158-5.404 c1.94-1.279,4.573-1.919,7.899-1.919c3.368,0,6.022,0.64,7.963,1.919c1.94,1.279,3.315,3.081,4.125,5.404 c0.81,2.325,1.215,5.064,1.215,8.22v21.556c0,3.112-0.395,5.863-1.184,8.251c-0.789,2.389-2.143,4.253-4.061,5.597 C401.121,467.26,398.435,467.932,394.981,467.932z M394.981,464.03c2.303,0,4.05-0.458,5.245-1.376 c1.193-0.916,2.015-2.195,2.463-3.837c0.448-1.642,0.671-3.551,0.671-5.725v-23.475c0-2.175-0.224-4.071-0.671-5.692 c-0.448-1.62-1.269-2.868-2.463-3.742c-1.194-0.874-2.942-1.311-5.245-1.311c-2.261,0-3.998,0.438-5.213,1.311 s-2.047,2.122-2.495,3.742c-0.448,1.621-0.672,3.518-0.672,5.692v23.475c0,2.174,0.224,4.083,0.672,5.725 c0.448,1.642,1.279,2.921,2.495,3.837C390.983,463.572,392.72,464.03,394.981,464.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M416.344,467.292v-51.81h11.705c3.24,0,5.789,0.523,7.644,1.567 c1.855,1.045,3.188,2.558,3.998,4.541c0.81,1.982,1.215,4.339,1.215,7.067c0,1.919-0.214,3.732-0.64,5.438 c-0.427,1.706-1.151,3.156-2.175,4.35c-1.023,1.193-2.474,1.982-4.35,2.366l7.932,26.48h-4.733l-7.611-25.457h-8.124v25.457 H416.344z M421.205,438.253h6.588c2.175,0,3.859-0.361,5.053-1.087c1.193-0.725,2.047-1.791,2.559-3.198 c0.512-1.407,0.768-3.177,0.768-5.31c0-3.198-0.555-5.585-1.663-7.163c-1.109-1.577-3.305-2.367-6.588-2.367h-6.716V438.253z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M275.155,218.786 l3.712,53.509l-23.198-10.826l-5.877,23.507c0,0,49.798,27.837,54.746,26.909c4.949-0.928-7.423-109.183-7.423-109.183 L275.155,218.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M308.588,347.875 c0,0,26.713-9.183,37.148-17.948c10.435-8.765-44.244-114.783-44.244-114.783S302.327,312.396,308.588,347.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M420.412,313.624 l-3.088,0.46c0.024,0.187,0.039,0.349,0.033,0.456c-0.234,3.97-21.701,14.539-36.857,20.257 c-3.314,2.567-7.748,3.862-13.327,3.862c-0.051,0-0.097-0.006-0.148-0.006c-11.698,1.126-34.171-4.024-39.252-7.499l-5.479,56.039 c0.001,0,0.002,0.001,0.002,0.001c0.882,0.433,1.782,0.848,2.69,1.256c11.873,5.262,25.928,7.904,42.187,7.904 c18.754,0,34.673-3.704,47.754-11.107c0.095-0.054,0.191-0.108,0.286-0.162c0.825-0.472,1.642-0.956,2.444-1.458 c0.968-0.605,1.914-1.23,2.847-1.868c0.286-0.195,0.564-0.396,0.847-0.594c0.654-0.459,1.302-0.925,1.939-1.4 c0.303-0.226,0.603-0.454,0.902-0.683c0.637-0.49,1.265-0.989,1.884-1.495c0.251-0.205,0.506-0.408,0.755-0.616 c0.85-0.712,1.687-1.436,2.502-2.18c0.002-0.002,0.004-0.003,0.005-0.005C425.843,349.997,420.412,313.624,420.412,313.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M300.645,248.546 c0,0,24.748,60.494,25.053,62.633c0.306,2.139-2.444,15.888,1.528,19.554c3.972,3.666,30.553,9.777,41.857,7.638 c11.305-2.139,47.968-18.637,48.273-23.831c0.306-5.194-36.358-106.629-40.941-118.85c-4.583-12.221-23.22-16.498-35.747-15.276 c-12.527,1.222-42.774,9.166-48.273,16.804C286.896,204.856,300.645,248.546,300.645,248.546z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M302.784,192.329c0,0-3.055,27.803-1.222,33.608c1.833,5.805,10.172,21.774,10.172,21.774s13.964-17.497,16.714-19.33 c2.75-1.833,28.109,14.36,28.109,14.36s0.917-17.415-2.75-31.775c-3.666-14.36-10.082-29.942-12.221-32.692 c-2.139-2.75-2.139,7.333-10.082,14.054C323.56,199.051,302.784,192.329,302.784,192.329z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M300.529,197.17c0,0,3.628,9.235,11.544,20.449c7.916,11.214,18.8,19.459,18.8,19.459s8.575-22.098,10.884-35.29 c2.309-13.193-1.649-26.385-1.649-26.385s-1.649,19.789-8.575,23.747C324.605,203.107,300.529,197.17,300.529,197.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M318.64,200.259c-8.734-0.776-18.111-3.088-18.111-3.088s3.628,9.235,11.544,20.449c0.764,1.082,1.56,2.126,2.366,3.148 l13.645-15.785L318.64,200.259z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M340.107,175.402c0,0,10.034,40.147,13.7,70.394c3.666,30.247,12.527,119.767,12.527,119.767s27.497-7.944,41.857-18.332 c14.36-10.388,18.943-17.415,18.943-17.415s-23.526-102.963-23.526-104.491c0-1.528,2.444-16.804,2.444-16.804 s41.552-19.554,57.439-31.469c15.887-11.916,11.916-18.332,4.277-21.387c-7.638-3.055-31.469,0.306-44.607,3.972 c-13.138,3.666-19.859,6.111-19.859,6.111s-14.665-1.222-28.109,1.833C361.751,170.637,340.107,175.402,340.107,175.402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M361.209,278.122c-0.485,1.522-1.014,3.157-1.597,4.949"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M365.918,210.118 l4.693,2.987c0,0-1.546,24.342-3.666,39.719c-1.277,9.262-2.395,14.343-4.461,21.198"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M357.618,181.128 c3.075,5.651,7.494,13.978,7.494,15.173c0,1.833-4.583,10.388-4.583,10.388l2.864,1.823"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M354.718,175.859c0,0,0.487,0.871,1.249,2.255"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M410.978,310.446 c-3.401,2.353-8.547,5.357-15.619,8.066c-14.36,5.5-16.804,6.416-16.804,6.416l2.139,7.333c0,0,25.053-4.583,36.663-17.721"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M416.135,306.291c0,0-0.667,0.699-2.052,1.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 411.531,192.298 406.052,208.522 418.884,189.274  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 413.996,
    y1: 184.997,
    x2: 412.73,
    y2: 188.746
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M302.784,192.329c0,0,3.055,55.606,6.416,82.798c3.361,27.192,8.86,94.408,8.86,94.408s-10.694-0.917-17.721-9.471 c-7.027-8.555-10.388-14.971-10.388-14.971s0-58.05,0-60.495c0-2.444-4.888-30.247-9.471-43.996 c-4.583-13.749-11.305-29.636-7.333-36.358c3.972-6.722,16.498-16.804,21.081-18.026 C298.812,184.997,302.478,186.219,302.784,192.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M301.069,262.167c1.727,5.398,3.404,10.192,4.77,13.266"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M290.623,202.919 c-0.515,3.968-0.763,7.04-0.366,7.437c1.222,1.222,6.111,5.5,6.111,5.5s-6.111,7.638-5.194,11.61 c0.602,2.61,4.634,17.751,8.715,30.949"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M293.923,182.552c0,0-1.611,8.757-2.752,16.45"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 297.494,
    y1: 323.798,
    x2: 292.09,
    y2: 321.262
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 292.09,313.013 307.061,319.123 307.061,328.289 300.213,325.075  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M279.957,155.569l5.222,12.795c0,0-6.789-7.05-8.356-0.783c-1.567,6.267,3.133,13.578,6.267,13.578 c3.133,0,6.789,0.261,6.789,0.261s10.967,19.322,17.756,22.978c6.789,3.656,15.928,6.789,21.672,3.656 c5.745-3.133,8.878-11.75,10.706-18.278s0.522-26.111,0.522-26.111l-9.4-38.645c0,0,6.528-2.35,6.528-6.789 c0-4.439-15.145-5.744-15.145-5.744s6.005-7.05-1.567-8.094c-7.572-1.044-32.117,13.578-32.9,14.1 c-0.783,0.522,4.178-9.139-2.089-5.744c-6.267,3.395-13.578,20.106-12.795,24.022 C273.952,140.685,279.957,155.569,279.957,155.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#737373",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M322.518,112.485c0,0,6.005-7.05-1.567-8.094c-7.572-1.044-32.117,13.578-32.9,14.1c-0.783,0.522,4.178-9.139-2.089-5.744 c-6.267,3.395-13.578,20.106-12.795,24.022c0.783,3.917,6.789,18.8,6.789,18.8l5.222,12.795c0,0,6.006,5.483,3.917,1.306 c-2.089-4.178-6.267-13.578-5.222-14.883c1.044-1.306,6.267-3.395,6.528-6.267c0.261-2.872-4.961-11.228-3.394-13.317 c1.567-2.089,23.761,1.828,27.678-0.522c3.917-2.35-1.044-8.095-1.044-8.095l17.495-1.567c0,0,6.528-2.35,6.528-6.789 C337.663,113.791,322.518,112.485,322.518,112.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M325.913,176.98 c0,0-2.35,4.439-6.006,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M309.724,164.969c0.729,1.57,0.418,3.26-0.694,3.777c-1.112,0.516-2.604-0.338-3.332-1.908 c-0.729-1.57-0.418-3.26,0.694-3.777C307.503,162.545,308.995,163.399,309.724,164.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M330.53,160.854c0.272,1.709-0.488,3.251-1.699,3.443c-1.21,0.193-2.412-1.036-2.685-2.745 c-0.272-1.709,0.488-3.251,1.699-3.443C329.056,157.916,330.258,159.145,330.53,160.854z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M319.907,191.602c0,0,4.439,0,7.572-2.35"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M296.668,161.574c0,0,3.656-5.222,13.578-2.089"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M323.041,156.613c0,0,1.828-6.006,8.878-6.528"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M337.663,151.391c0,0,1.828-4.178,3.917-1.567c2.089,2.611,2.872,7.833,1.567,11.228c-1.306,3.395-2.089,6.267-2.089,6.267 l-0.522-3.656L337.663,151.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M385.708,131.024c0,0-28.722-5.222-30.55-5.222c-1.828,0-23.239,3.917-26.372,5.222c-3.133,1.306-26.895,8.095-26.372,9.661 c0.522,1.567,3.394,2.089,3.394,2.089s0.522,2.35,8.878,3.395c8.356,1.044,27.939-1.567,28.2,0.261 c0.261,1.828-1.306,3.394-1.306,3.394l2.35,4.178c0,0,8.617-1.306,11.489-3.395c2.872-2.089,10.967-8.617,10.967-8.617 l17.495,1.305L385.708,131.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M321.996,134.68 c0,0-11.75,4.961-13.578,6.006c-1.828,1.044,3.394,3.133,6.528,2.611c3.133-0.522,15.145-5.222,16.972-5.745 c1.828-0.522,10.183,1.567,16.189,2.35c6.006,0.783,10.183-1.044,11.228-1.567"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M456.464,172.775 c0,0-9.166,2.444-20.165,0c-10.999-2.444-40.024-16.804-40.024-16.804l-19.859-5.805l4.583-23.22c0,0,50.107,6.11,64.161,11.304 s34.525,17.11,33.914,21.387c-0.611,4.277-11.916,13.443-11.916,13.443"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M284.365,272.605 c0,0,18.385,21.066,33.897,13.98c15.512-7.086,23.172-52.473,23.172-52.473"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M260.235,256.71 c0,0,14.555,18.193,33.897,16.47c19.342-1.723,25.854-24.13,25.662-35.237"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.497,
    y: 243.497,
    transform: "matrix(0.9479 0.3185 -0.3185 0.9479 95.9607 -69.5681)",
    style: {
      fill: "#7D7D7D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 6.478,
    height: 30.378
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.903,
    y: 240.996,
    transform: "matrix(0.9479 0.3185 -0.3185 0.9479 91.3088 -72.027)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.052,
    height: 4.468
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 271.049,
    y: 248.05,
    transform: "matrix(0.9479 0.3185 -0.3185 0.9479 98.1162 -73.6468)",
    style: {
      fill: "#7D7D7D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 6.478,
    height: 30.378
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.455,
    y: 245.548,
    transform: "matrix(0.9479 0.3185 -0.3185 0.9479 93.4634 -76.1051)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 10.052,
    height: 4.467
  })), /*#__PURE__*/React.createElement("rect", {
    x: 255.769,
    y: 252.7,
    transform: "matrix(0.9479 0.3185 -0.3185 0.9479 98.0402 -71.0362)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 20.997,
    height: 23.231
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D7D7D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 254.319,286.692 235.751,280.454 245.595,264.203 256.284,267.794  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.931,
    y: 283.032,
    transform: "matrix(0.9479 0.3185 -0.3185 0.9479 106.034 -61.7046)",
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.588,
    height: 20.787
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.764,
    y: 245.978,
    transform: "matrix(0.9479 0.3185 -0.3185 0.9479 94.8814 -67.5987)",
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 16.82,
    height: 20.787
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D7D7D",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 281.422,295.798 262.854,289.56 272.698,273.309 283.387,276.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.034,
    y: 292.138,
    transform: "matrix(0.9479 0.3185 -0.3185 0.9479 110.3469 -69.8627)",
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 19.588,
    height: 20.787
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.867,
    y: 255.083,
    transform: "matrix(0.9479 0.3185 -0.3185 0.9479 99.1912 -75.7554)",
    style: {
      fill: "#636363",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 16.82,
    height: 20.787
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M243.204,242.526c0,0-2.164,3.564-1.527,4.582c0.636,1.018,6.873,4.455,7.764,4.709c0.891,0.254,3.309-1.018,3.182-2.673 c-0.127-1.655-4.964-5.218-6.491-6.109C244.604,242.144,243.84,242.017,243.204,242.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M239.776,249.568c0,0-1.043,4.037-0.14,4.828s7.866,2.281,8.793,2.268s2.874-1.93,2.275-3.478 c-0.599-1.547-6.259-3.564-7.978-3.976C241.006,248.798,240.238,248.897,239.776,249.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M237.867,256.569c0,0-1.043,4.037-0.14,4.828c0.903,0.791,7.866,2.281,8.793,2.268c0.926-0.014,2.874-1.93,2.275-3.478 c-0.599-1.548-6.259-3.564-7.978-3.976C239.097,255.799,238.329,255.897,237.867,256.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M238.758,263.314c0,0-1.043,4.037-0.14,4.828s7.866,2.281,8.793,2.268c0.926-0.014,2.874-1.93,2.275-3.478 c-0.599-1.548-6.259-3.564-7.978-3.976C239.988,262.544,239.22,262.643,238.758,263.314z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.f42cd4bb6fc9e373b43fa8949c39325a.svg";
export { ForwardRef as ReactComponent };